import React, { useEffect, useState, useContext } from 'react'
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import LinePlot from './LinePlotGraph';
import OrganiserLinePlot from './OrganisersLinePlotGraph';
import BarChart from './BarPlotGraph';
import SingleBarPlotGraph from './SingleBarPlotGraph';
import { useSelector, useDispatch } from 'react-redux';
import { EnvironmentContext } from '../../EnvironmentContext';
import { useNavigate, } from 'react-router-dom';
import { setEventMetricsData, setUsersMetricsData, setOrganisersMetricsData, setBookingMetricsData } from '../../Redux/Actions';
import apiconfig from '../../config/config';
import "moment-timezone";
import APIServices from '../../services/APIServices';
import './Reporting.css';
import { setAccessToken } from '../../Redux/Actions';
import { Backdrop, CircularProgress } from '@mui/material';

const Reporting = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const { environment } = useContext(EnvironmentContext)
    const [EventsData, setEventsData] = useState([]);
    const [allOrganisersRatings, setAllOrganisersRating] = useState([])
    const [allEvents, setAllEvents] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const allUsers = useSelector((state) => state.allUserDetails);

    const getValidUsers = () => {
        const users = allUsers.filter((eachUser) => {
            return eachUser?.firstName !== null
        })
        return users
    }
    const getAllOrganisers = () => {
        const allOrganisers = allUsers.filter((eachUser) => eachUser?.user_type === 'organiser')
        return allOrganisers
    }

    console.log(getAllOrganisers())

    console.log(getValidUsers())

    const getSignupReport = (users) => {
        const months = [0, 1, 2, 3, 4, 5].map(i => {
            const date = new Date();
            date.setMonth(date.getMonth() - i);
            return date.getMonth() + 1; // months are 0-based in JavaScript
        }).reverse(); // Get last 6 months

        const userReportsData = months.map(month => {
            return users.filter(user => {
                const signupDate = new Date(user.signup_date[0]); // Assuming signup_date is in YYYY-MM-DD format
                return signupDate.getMonth() + 1 === month && signupDate.getFullYear() === new Date().getFullYear();
            }).length;
        });

        return userReportsData;
    };

    const getOrganiserReport = (users) => {
        const months = [0, 1, 2, 3, 4, 5].map(i => {
            const date = new Date();
            date.setMonth(date.getMonth() - i);
            return date.getMonth() + 1; // months are 0-based in JavaScript
        }).reverse(); // Get last 6 months

        const organiserReportsData = months.map(month => {
            return users.filter(user => {
                const organiserDate = new Date(user.organiser_date[0]); // Assuming organiser_date is in YYYY-MM-DD format
                return organiserDate.getMonth() + 1 === month && organiserDate.getFullYear() === new Date().getFullYear();
            }).length;
        });

        return organiserReportsData;
    }


    function getEventsMetricsData(allEvents) {
        const now = new Date();
        const eventsMetricsData = Array.from({ length: 6 }, (_, i) => {
            const start = new Date(now.getFullYear(), now.getMonth() - i, 1);
            const end = new Date(now.getFullYear(), now.getMonth() - i + 1, 1);

            const filteredEvents = allEvents.filter(event => {
                const eventDate = new Date(event.event_created_at);
                return eventDate >= start && eventDate < end;
            });

            const paidCount = filteredEvents.filter(event => !event.is_event_free).length;
            const freeCount = filteredEvents.filter(event => event.is_event_free).length;

            return { paid: paidCount, free: freeCount };
        }).reverse();

        return eventsMetricsData;
    }


    const eventsMetricsData = getEventsMetricsData(allEvents);
    console.log(eventsMetricsData);


    const userReportsDataCount = getSignupReport(getValidUsers());

    // const organiserReportsData = [100, 150, 200, 300, 400, 450, 470];
    const organiserReportsData = getOrganiserReport(getAllOrganisers())
    console.log(organiserReportsData)
    const bookingMetricsData = [100, 50, 200, 300, 250, 500]
    const eventsDataMetrics = useSelector((state) => state.eventMetricsData);
    const usersDataMetrics = useSelector((state) => state.usersMetricsData);
    const organisersDataMetrics = useSelector((state) => state.organisersMetricsData);
    const bookingDataMetrics = useSelector((state) => state.bookingMetricsData);
    const accessToken = useSelector((state) => state.accessToken);

    useEffect(() => {
        const tokenLocal = JSON.parse(localStorage.getItem("token"));
        if (!accessToken && tokenLocal) {
            dispatch(setAccessToken(tokenLocal));
            APIServices.setAuthToken(tokenLocal);
        } else if (!accessToken && !tokenLocal) {
            navigate("/login");
        }

        if (accessToken || tokenLocal) {
            const tokenToUse = accessToken || tokenLocal;
            setIsLoading(true);
            APIServices.setAuthToken(tokenToUse);
            const url = environment === "Production"
                ? apiconfig.production.apiBaseUrl
                : apiconfig.develpoment.apiBaseUrl;

            APIServices.setApiBaseUrl(url);
            APIServices.getAllEvents()
                .then((response) => {
                    setIsLoading(false);
                    setEventsData(response?.data?.Events)
                })
                .catch((err) => {
                    setIsLoading(false);
                    console.log("Error While Fetching All Events: ", err);
                });

            APIServices.getAllEvents()
                .then((response) => {
                    setIsLoading(false);
                    setAllEvents(response.data.Events)
                })
                .catch((err) => {
                    setIsLoading(false);
                    console.log("Error While Fetching All Events: ", err);
                });

            APIServices.getAllOrganisersRatings()
                .then((response) => {
                    console.log("response: ", response)
                    setIsLoading(false);
                    setAllOrganisersRating(response.data.Feedbacks)
                })
                .catch((err) => {
                    setIsLoading(false);
                    console.log("Error While Fetching All Organisers Ratings: ", err);
                });
            APIServices.getEventParticipationRating()
                .then((response) => {
                    console.log(response.data)
                    dispatch(setUsersMetricsData(response.data));
                    setIsLoading(false);
                })
                .catch((err) => {
                    setIsLoading(false);
                    console.log("Error While Fetching Getting Total Users Engaged: ", err);
                });

            APIServices.getTotalOrganisersEngaged()
                .then((response) => {
                    console.log(response.data)
                    dispatch(setOrganisersMetricsData(response.data));
                    setIsLoading(false);
                })
                .catch((err) => {
                    setIsLoading(false);
                    console.log("Error While Fetching Getting Total Users Engaged: ", err);
                });

            APIServices.getTotalEventsSummary()
                .then((response) => {
                    dispatch(setEventMetricsData(response.data));
                    setIsLoading(false);
                })
                .catch((err) => {
                    setIsLoading(false);
                    console.log("Error While Fetching Getting Total Users Engaged: ", err);
                });

            APIServices.getAllRevenueData()
                .then((response) => {
                    console.log(response.data)
                    dispatch(setBookingMetricsData(response.data));
                    setIsLoading(false);
                })
                .catch((err) => {
                    setIsLoading(false);
                    console.log("Error While Fetching Getting Total Users Engaged: ", err);
                });
        }
    }, [environment, dispatch, accessToken, navigate]);


    const getAllOrganisersEnagageCount = () => {
        const totalOrganisersEngage = getAllOrganisers().filter((eachOrganiser) => eachOrganiser?.my_organized_trips && eachOrganiser?.my_organized_trips !== 0)
        return totalOrganisersEngage
    }

    function OrganiserParticipationRate() {
        const totalParticipantRate = getAllOrganisersEnagageCount().length / EventsData.length * 100
        return totalParticipantRate.toFixed(2);
    }

    const getOverAllOrganisersRatings = () => {
        let totalRatings = 0
        allOrganisersRatings.forEach((eachFeedback) => {
            totalRatings += parseFloat(eachFeedback?.organiser_rating) || 0
        })
        const averageRating = totalRatings / (allOrganisersRatings.length * 5);
        const averageRatingPercentage = averageRating * 100;
        return averageRatingPercentage.toFixed(2)
    }

    const getOverAllUsersRatings = () => {
        const uniqueUsers = allOrganisersRatings.filter((eachFeedback, index, self) =>
            index === self.findIndex((feedback) => (
                feedback.rated_by === eachFeedback.rated_by
            ))
        );
        const averageRating = uniqueUsers.length / allUsers.length * 100
        return averageRating.toFixed(2)
    };

    const navigateToEventMetricDetailPage = () => {
        navigate('/reporting/eventmetrics')
    }

    const navigateToBookingMetricDetailPage = () => {
        navigate('/reporting/bookingmetrics')
    }

    const navigateToOrganiserReportDetailPage = () => {
        navigate('/reporting/organiserreport')
    }

    return (
        <>
            <Backdrop
                sx={{
                    color: "#ffffff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <div className='reporting-bg-container'>
                <div>
                    <h3 className='reporting-section-heading'>User report</h3>
                    <div className='reporting-sub-containers'>
                        <div className="reporting-details-content-container">
                            <div className="details-content-container">
                                <h5 className="reporting-information-side-heading">Total users</h5>
                                <p className="reporting-information-content"> {usersDataMetrics?.totalUsers} </p>
                            </div>
                            <div className="details-content-container">
                                <h5 className="reporting-information-side-heading">Total users engaged</h5>
                                <p className="reporting-information-content"> {usersDataMetrics?.totalEngagedUsers} </p>
                            </div>
                            <div className="details-content-container">
                                <h5 className="reporting-information-side-heading">Overall rating</h5>
                                <p className="reporting-information-content"> {getOverAllUsersRatings()}% </p>
                            </div>
                            <div className="details-content-container">
                                <h5 className="reporting-information-side-heading">Total active users</h5>
                                <p className="reporting-information-content"> NA </p>
                            </div>
                            <div className="details-content-container">
                                <h5 className="reporting-information-side-heading">Event participation rate</h5>
                                <p className="reporting-information-content"> {usersDataMetrics?.eventParticipationRate}% </p>
                            </div>

                        </div>
                        <div className='reporting-graph-container'>
                            {/* <h5>Graph Representation</h5> */}
                            <LinePlot data={userReportsDataCount} width={440} height={300} />
                        </div>
                        <button className='reporting-detailed-btn' onClick={navigateToOrganiserReportDetailPage}>View detailed report <KeyboardDoubleArrowRightIcon /></button>
                    </div>
                </div>

                <div>
                    <h3 className='reporting-section-heading'>Organisers report</h3>
                    <div className='reporting-sub-containers'>
                        <div className="reporting-details-content-container">
                            <div className="details-content-container">
                                <h5 className="reporting-information-side-heading">Total Organisers</h5>
                                <p className="reporting-information-content"> {organisersDataMetrics?.totalOrganizers} </p>
                            </div>
                            <div className="details-content-container">
                                <h5 className="reporting-information-side-heading">Overall organisers rating</h5>
                                <p className="reporting-information-content"> {getOverAllOrganisersRatings()}% </p>
                            </div>
                            <div className="details-content-container">
                                <h5 className="reporting-information-side-heading">Total organisers engaged</h5>
                                <p className="reporting-information-content"> {organisersDataMetrics?.totalEngagedOrganizers} </p>
                            </div>
                            <div className="details-content-container">
                                <h5 className="reporting-information-side-heading">Total active organisers</h5>
                                <p className="reporting-information-content"> NA </p>
                            </div>
                            <div className="details-content-container">
                                <h5 className="reporting-information-side-heading">Organiser participation rate</h5>
                                <p className="reporting-information-content"> {OrganiserParticipationRate()}% </p>
                            </div>
                        </div>
                        <div className='reporting-graph-container'>
                            <OrganiserLinePlot data={organiserReportsData} width={440} height={300} />
                        </div>
                        <button className='reporting-detailed-btn' onClick={navigateToOrganiserReportDetailPage}>View detailed report <KeyboardDoubleArrowRightIcon /></button>
                    </div>
                </div>

                <div>
                    <h3 className='reporting-section-heading'>Event metrics</h3>
                    <div className='reporting-sub-containers'>
                        <div className="reporting-details-content-container">
                            <div className="details-content-container">
                                <h5 className="reporting-information-side-heading">Total Events</h5>
                                <p className="reporting-information-content"> {eventsDataMetrics?.totalEvents} </p>
                            </div>
                            <div className="details-content-container">
                                <h5 className="reporting-information-side-heading">Total events engaged</h5>
                                <p className="reporting-information-content"> NA </p>
                            </div>
                            <div className="details-content-container">
                                <h5 className="reporting-information-side-heading">Total paid events</h5>
                                <p className="reporting-information-content"> {eventsDataMetrics?.totalPaidEvents} </p>
                            </div>
                            <div className="details-content-container">
                                <h5 className="reporting-information-side-heading">Total donation events</h5>
                                <p className="reporting-information-content"> NA </p>
                            </div>
                            <div className="details-content-container">
                                <h5 className="reporting-information-side-heading">Total Free events</h5>
                                <p className="reporting-information-content"> {eventsDataMetrics?.totalFreeEvents} </p>
                            </div>
                            <div className="details-content-container">
                                <h5 className="reporting-information-side-heading">Total upcoming events</h5>
                                <p className="reporting-information-content"> {eventsDataMetrics?.totalUpcomingEvents} </p>
                            </div>
                            <div className="details-content-container">
                                <h5 className="reporting-information-side-heading">Total Cancelled events</h5>
                                <p className="reporting-information-content"> {eventsDataMetrics?.totalCancelledEvents} </p>
                            </div>

                        </div>
                        <div className='reporting-graph-container'>
                            {/* <h5>Graph Representation</h5> */}
                            <BarChart data={eventsMetricsData} width={540} height={400} />
                        </div>
                        <button className='reporting-detailed-btn' onClick={navigateToEventMetricDetailPage}>View detailed report <KeyboardDoubleArrowRightIcon /></button>
                    </div>
                </div>

                <div>
                    <h3 className='reporting-section-heading'>Booking metrics</h3>
                    <div className='reporting-sub-containers'>
                        <div className="reporting-details-content-container">
                            <div className="details-content-container">
                                <h5 className="reporting-information-side-heading">Total Revenue</h5>
                                <p className="reporting-information-content">{bookingDataMetrics?.totalRevenue} </p>
                            </div>
                            {/* <div className="details-content-container">
                            <h5 className="reporting-information-side-heading">Total</h5>
                            <p className="reporting-information-content"> 423456 </p>
                        </div> */}
                            <div className="details-content-container">
                                <h5 className="reporting-information-side-heading">Total users booked paid events </h5>
                                <p className="reporting-information-content"> {bookingDataMetrics?.totalUsersBookedPaid} </p>
                            </div>
                            <div className="details-content-container">
                                <h5 className="reporting-information-side-heading">Total users booked free events </h5>
                                <p className="reporting-information-content"> {bookingDataMetrics?.totalUsersBookedFree} </p>
                            </div>
                            <div className="details-content-container">
                                <h5 className="reporting-information-side-heading">Total free cancellations</h5>
                                <p className="reporting-information-content"> {bookingDataMetrics?.totalCancellationsFree} </p>
                            </div>
                            <div className="details-content-container">
                                <h5 className="reporting-information-side-heading">Total Paid cancellations</h5>
                                <p className="reporting-information-content">{bookingDataMetrics?.totalCancellationsPaid} </p>
                            </div>

                        </div>
                        <div className='reporting-graph-container'>
                            {/* <h5>Graph Representation</h5> */}
                            <SingleBarPlotGraph data={bookingMetricsData} width={440} height={300} />
                        </div>
                        <button className='reporting-detailed-btn' onClick={navigateToBookingMetricDetailPage}>View detailed report <KeyboardDoubleArrowRightIcon /></button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Reporting
